import styles from './PercentInput.module.css'

export const percentageBoundary = (
  value: number | null,
  limit?: number | null
) => {
  if (value && limit && value < limit) {
    return styles.belowLimitPercentInputHolder
  }
  return styles.percentInputHolder
}
